import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { UserInfo } from "CommonLibrary";
import HealthFile from "../common/HealthFile";
// import { Environment } from '../utils/Environment';
const CloseTheLoop = lazy(() => import('../component/screens/closeTheLoop'))

// const LOGIN_ROOT = `${Environment.getLoginUrl()}`;

//const LOGIN_ROOT =`http://localhost:3000`;

const route = (<React.Fragment>
    <Routes>
        <Route path="/health" element={<HealthFile />} />
        <Route path="/" element={<CloseTheLoop />} />
        <Route path="/myinfo" element={<UserInfo />} />
    </Routes>
</React.Fragment>
)

export default route
